  import React from "react";
  import { usePermissions } from "./PermissionContext";
  import { useModule } from "./ModuleContext";

  const PermissionWrapper = ({ permissionKey, moduleId, children, fallback = null }) => {
    const { activeModuleId } = useModule();
    const { getModulePermission } = usePermissions();

    const targetModuleId = moduleId || activeModuleId;

    // Get permission object for current active module
    const permission = getModulePermission(targetModuleId);

    // Check if permission exists and permissionKey is exactly "1"
    const isAllowed = permission && permission[permissionKey] === "1";

    return isAllowed ? children : fallback;
  };

  export default PermissionWrapper;
